import { useState } from 'react';
import { Tabs } from 'antd';
import { useLocation, useHistory } from 'react-router-dom';
import ExpenditureReports     from './sn_expenditure_reports/ExpenditureReports';
import BudgetReports          from './sn_expenditure_reports/BudgetReports';
import ApprovalWorkflowReport from './sn_expenditure_reports/ApprovalWorkflowReport';
import { MonthlyReportList }  from './sn_monthly_reports';

const { TabPane } = Tabs;

const TABS = [
  { key: 'expenditure-reports', label: 'Expenditure Reports', Component: ExpenditureReports },
  { key: 'budget-reports',      label: 'Budget Reports',      Component: BudgetReports },
  { key: 'approval-analytics',  label: 'Approval Analytics',  Component: ApprovalWorkflowReport },
  { key: 'monthly-reports',     label: 'Monthly Reports',     Component: MonthlyReportList },
];

export default function FinancialReports() {
  const location = useLocation();
  const history  = useHistory();
  const params   = new URLSearchParams(location.search);
  const [active, setActive] = useState(params.get('tab') || 'expenditure-reports');

  const switchTab = (key) => {
    setActive(key);
    history.replace(`/financial-reports?tab=${key}`);
  };

  const ActiveComponent = TABS.find(t => t.key === active)?.Component || ExpenditureReports;

  return (
    <div style={{ background: '#f0f2f5', minHeight: '100vh' }}>
      <div style={{ background: '#fff', borderBottom: '2px solid #e2e8f0', padding: '0 24px' }}>
        <Tabs
          activeKey={active}
          onChange={switchTab}
          style={{ marginBottom: 0 }}
          tabBarStyle={{ marginBottom: 0 }}
        >
          {TABS.map(t => <TabPane tab={<span style={{ fontWeight: 600, fontSize: 13 }}>{t.label}</span>} key={t.key} />)}
        </Tabs>
      </div>
      <ActiveComponent />
    </div>
  );
}
